import React from 'react';
import { Alert as AntdAlert } from 'antd';
import classNames from 'classnames';
import styles from './alert.module.scss';

interface Props {
	type: 'error' | 'info' | 'success' | 'warning';
	message: string;
	className?: string;
	closable?: boolean;
	banner?: boolean;
	showIcon?: boolean;
	description?: string;
	['data-test-id']?: string;
}

const Alert: React.FunctionComponent<Props> = (props: Props) => {
	const classByType = styles[props.type];
	return <AntdAlert {...props} className={classNames(styles.bringgAlert, classByType, props.className)} />;
};

export default Alert;
